import getParents from "./getParents";

export default class Navigation {

    /*
    options:
        unloadTimeout : 1000
     */

    /*
        navigation-open
        navigation-close
     */

    constructor(options) {
        if (options === undefined) {
            options = {};
        }
        this.options = {
            unloadTimeout: options.unloadTimeout ? options.unloadTimeout : 300,
            mobileBreakpoint: options.mobileBreakpoint ? options.mobileBreakpoint : 991,
        }
        window.addEventListener('load', (e) => {
            this.init();
        });
    }

    init() {
        let elements = document.querySelectorAll('[data-open-nav]')
        if (elements.length) {
            elements.forEach((v, k) => {
                v.addEventListener('click', (event) => {
                    let nav = document.getElementById(v.dataset["nav"]);
                    if (nav) {
                        let navWrapper = getParents(nav, ".nav-wrapper")
                        if (v.classList.contains('collapsed')) {
                            this.openNav(navWrapper[0], v);
                        } else {
                            this.closeNav(navWrapper[0], v);

                        }
                    }
                });
                window.addEventListener('nav-close', () => {
                    let nav = document.getElementById(v.dataset["nav"]);
                    if (nav) {
                        let navWrapper = getParents(nav, ".nav-wrapper")
                        this.closeNav(navWrapper[0], v);
                    }
                });
            });
        }
        let navDropdowns = document.querySelectorAll('.navbar-nav .dropdown');
        if (navDropdowns.length) {
            navDropdowns.forEach((v) => {
                if (v.children.length === 1) {
                    return;
                }
                let toggler = v.querySelector('.dropdown-wrapper-toggler');
                toggler.addEventListener('click', (e) => {
                    if (window.innerWidth > this.options.mobileBreakpoint)
                        return;
                    e.preventDefault();

                    navDropdowns.forEach((iV) => {
                        if (v === iV)
                            return;
                        iV.classList.remove("open");
                    });
                    v.classList.toggle("open");

                    return false;
                });
            });
        }
        let header = document.querySelector('header');
        window.addEventListener("scroll", () => {
            if (window.scrollY > 0) {
                document.body.classList.add("scrolled");
            } else {
                document.body.classList.remove("scrolled");
            }
            setTimeout(() => {
                document.body.style.setProperty('--header-height', `${header.getBoundingClientRect().height}px`);
            }, 300);
        }, {passive: true})
    }

    openNav(nav, triggerElement) {
        document.body.classList.add("nav-open");
        if (nav.classList.contains('left-right')) {
            nav.style.left = 0;
        }
        document.querySelector('.hamburger').classList.add('is-active');
        let triggers = document.querySelectorAll(`[data-nav="${triggerElement.dataset["nav"]}"]`);
        triggers.forEach((v, k) => {
            v.classList.remove('collapsed');
        });
        if (nav.dispatchEvent) {
            nav.dispatchEvent(new CustomEvent('navigation-open'));
        }
    }

    closeNav(nav, triggerElement) {
        document.body.classList.remove("nav-open");
        if (nav.classList.contains('left-right')) {
            nav.style.left = "";
        }
        document.querySelector('.hamburger').classList.remove('is-active');
        let triggers = document.querySelectorAll(`[data-nav="${triggerElement.dataset["nav"]}"]`);
        triggers.forEach((v, k) => {
            v.classList.add('collapsed');
        });
        if (nav.dispatchEvent) {
            nav.dispatchEvent(new CustomEvent('navigation-close'));
        }
    }

}
